// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_BuscaOrigensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/origens/buscaOrigens
 * (also mounted at two additional URLs that resolve to the same method).
 *
 * Returns an id-keyed map of `{ <origem_id>: <origem_nome> }` produced by
 * Origens_model::retornaSelectOrigensCRUD() — used by legacy CRUD UIs that
 * expect a flat option map. Dynamic numeric keys mean a Row class would
 * mis-shape this into a list, so we keep it as a typed map.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Origens_BuscaOrigensResponseDados = Record<number, string>;

export type Origens_BuscaOrigensResponse = ApiResponse<Origens_BuscaOrigensResponseDados>;

registerResponseContract('Origens_BuscaOrigensResponse', {})
